import { Module } from 'vuex';
import { RootState, dailyLottoState } from '@/types/store';

import state from '@/store/modules/dailyLotto/state';
import actions from '@/store/modules/dailyLotto/action';
import mutations from '@/store/modules/dailyLotto/mutations';
import getters from '@/store/modules/dailyLotto/getters';

const lotto: Module<dailyLottoState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default lotto;
